import BC from '../init';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default BC.Methods.propertyItemSlider = ($this) => {
    const swiperEl = $this.querySelector('.swiper');
    const prev = $this.querySelector('.swiper-button-prev');
    const next = $this.querySelector('.swiper-button-next');

    new Swiper(swiperEl, {
        modules: [Navigation],
        speed: 600,
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
            prevEl: prev,
            nextEl: next
        }
    });
};
